.component {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--light-grey);
}

.content {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
}
